<template>
  <v-btn
    depressed
    fab
    tile
    small
    text
    active-class="is-active"
    :class="{
      'suus__menu-item': true,
      'is-active': isActive ? isActive() : null,
    }"
    @click="action"
    :title="title"
  >
    <v-badge v-if="badge?.value" :content="badge?.value">
      <v-icon color="primary">{{ icon }}</v-icon>
    </v-badge>
    <v-icon v-else color="primary">{{ icon }}</v-icon>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent, PropType, Ref } from "vue"

export type MenuItemObject = CustomMenuItemObject | { type: string }

export type CustomMenuItemObject = {
  icon: string
  title: string
  action: () => void
  isActive?: () => boolean
  badge?: Ref<number>
}

export default defineComponent({
  name: "MenuItem",
  props: {
    icon: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    action: {
      type: Function,
      required: true,
    },

    isActive: {
      type: Function,
      default: null,
    },
    badge: {
      type: Object as PropType<Ref<number>>,
      default: null,
    },
  },
})
</script>

<style lang="sass" scoped>
.suus__menu-item
    &.is-active
        background-color: #e5e5e5 !important
    &--dark
        &.is-active
            background-color: rgba(#e5e5e5, 0.1) !important
</style>
